import { FC, PropsWithChildren } from 'react';

import { useApplicationConfig, useEnvironment } from '@bonusly/application';

import { useInitTelemetry } from './hooks/use-init-telemetry';

export const TelemetryProvider: FC<PropsWithChildren> = ({ children }) => {
	useInitTelemetry({
		applicationId: useApplicationConfig('datadogApplicationId'),
		clientToken: useApplicationConfig('datadogClientToken'),
		service: 'monarch',
		env: useEnvironment() || 'development',
	});

	return <>{children}</>;
};
